import { useEffect, useState } from 'react';
import { useFlipperExperimentBucketQueryLazyQuery, useMembershipQuery } from '../generated/graphql';

export const useFlipper = (experimentId: string, controlVariant: string) => {
  const [variant, setVariant] = useState<string>(controlVariant);
  const [loading, setLoading] = useState(true);
  const { data: memberData, loading: memberLoading } = useMembershipQuery();
  const [callFlipperAssignment, { data: variantData, error }] = useFlipperExperimentBucketQueryLazyQuery();

  useEffect(() => {
    if (memberLoading || memberData?.member?.id === undefined) return;

    callFlipperAssignment({
      variables: {
        flipperExperimentBucketExperimentId: experimentId,
        flipperExperimentBucketId: memberData.member.id,
      },
    });
  }, [experimentId, memberLoading, memberData, callFlipperAssignment]);

  useEffect(() => {
    // update variant and loading state if we have a variant_name from the service
    if (variantData?.flipperExperimentBucket?.variant_name) {
      setVariant(prevVariant => variantData?.flipperExperimentBucket?.variant_name || prevVariant);
      setLoading(false);
    }

    if (error) {
      setLoading(false);
    }
  }, [variantData, error]);

  return { variant, loading };
};
